import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./lib/auth-context";
import Topbar from "./components/Topbar";
import Landing from "./pages/Landing";
import AccessCode from "./pages/AccessCode";
import EnterBlazerid from "./pages/EnterBlazerid";
import Practice from "./pages/Practice";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import AdminQuestionDetail from "./pages/AdminQuestionDetail";
import About from "./pages/About";

export default function App() {
  return (
    <AuthProvider>
      <div className="shell">
        <Topbar />
        <main>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/access-code" element={<AccessCode />} />
            <Route path="/enter-blazerid" element={<EnterBlazerid />} />
            <Route path="/practice" element={<Practice />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/questions/:qid" element={<AdminQuestionDetail />} />
            <Route path="/about" element={<About />} />
            {/* Legacy magic-link route: bounce to the new entry. */}
            <Route path="/login" element={<Navigate to="/access-code" replace />} />
          </Routes>
        </main>
      </div>
    </AuthProvider>
  );
}
